import React from 'react';
import ResultPageModal, { capitalizeTitle } from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModal';

function AncillariAutoModal({
  insuranceRequest,
  addingQuote,
  quotations,
  selectQuotation,
  type,
  processingQuote,
}) {
  let title = capitalizeTitle(type.name);
  if (type.id === 'res_civile' && insuranceRequest.product.id === 11) {
    title = 'Incendio Fabbricato';
  } else if (type.id === 'res_civile' && insuranceRequest.product.id === 13) {
    title = 'Furto e Incendio';
  }

  return (
    <ResultPageModal
      type={type}
      title={title}
      insuranceRequest={insuranceRequest}
      addingQuote={addingQuote}
      quotations={quotations}
      selectQuotation={selectQuotation}
      processingQuote={processingQuote}
    />
  );
}

export default AncillariAutoModal;
